'use client';

import { useUser } from '@/store';
import ds from '@/styles/ds/ds.module.scss';
import React, { useEffect } from 'react';

interface Country {
	id: number;
	code: string;
	name: string;
}

interface Input_CountryProps {
	countries: Country[];
	country: string;

	postalCode: string;
	setPostalCode: (postalCode: string) => void;

	setCountry: (country: string) => void;
}

const Input_Country = ({
	countries,
	country,
	setCountry,
}: Input_CountryProps) => {
	const user = useUser();

	useEffect(() => {
		if (user?.country?.code && countries?.length) {
			setCountry(user.country.code || '');
		} else if (user?.addresses?.[0] && countries?.length) {
			setCountry(user.addresses[0].countryCode || '');
		}
	}, [user, countries, setCountry]);

	const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		setCountry(e.target.value);
	};

	return (
		<>
			<div className="flex flex-col gap-4 w-full relative justify-center">
				<label htmlFor="country" className="text-sm font-bold">
					What is your country of residence?
				</label>
				<div className="flex items-center relative">
					<select
						id="country"
						name="country"
						value={country}
						onChange={handleCountryChange}
						className={`${ds.inputContainer} h-10 outline-none !px-4 appearance-none`}
					>
						<option value="" disabled>
							Country
						</option>
						{countries?.map((c) => (
							<option key={c.id} value={c.code}>
								{c.name}
							</option>
						))}
					</select>
					<div className="pointer-events-none absolute inset-y-0 right-3 flex items-center h-full">
						<svg
							className="w-4 h-4"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M19 9l-7 7-7-7"
							/>
						</svg>
					</div>
				</div>
			</div>
		</>
	);
};

export default Input_Country;
